<template>
    <div>
        <div class="flex-between">
            <el-button
                class="primary"
                type="primary"
                @click="add()"
            >新增</el-button>
        </div>
        <div>
            <el-table
                :header-cell-style="{
					background: 'rgba(229,244,255,1)',
					color: '#0077CC',
					fontWeight: 'bold'
				}"
                align="center"
                header-align="center"
                :data="tableData"
                style="width: 100%"
            >
                <el-table-column type="index" label="序号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="filePath" label="封面" header-align="center" align="center">
                    <template slot-scope="scope">
                        <img :src="httpUrl+'/disk/'+scope.row.filePath" alt="">
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="用户名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="belong" label="所属行业" header-align="center" align="center"></el-table-column>
                <el-table-column label="操作" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" class="" @click="edit(scope.row.id)">编辑</el-button>
                        <el-button type="text" @click="del(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="flex-end">
            当前 第 {{queryData.currentPage}} 页，共 {{queryData.pages}} 页 {{queryData.total}} 条记录
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryData.currentPage"
                :page-size="queryData.pageSize"
                layout="prev, pager, next, jumper"
                :total="queryData.total"
                style="padding: 45px; text-align:right;"
            ></el-pagination>
        </div>
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="60%"
            :close-on-click-modal="false"
            :before-close="cancel"
            >
            <div>
                <el-form
                    :model="form"
                    label-width="100px"
                >
                    <el-form-item label="用户名称">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="所属行业">
                        <el-input v-model="form.belong"></el-input>
                    </el-form-item>
                    <el-form-item label="封面">
                        <el-upload
                            class="avatar-uploader"
                            :action="`${httpUrl}/file/UploadPng`"
                            :show-file-list="false"
                            :on-success="successFun"
                        >
                            <img
                                v-if="form.filePath"
                                :src="httpUrl+'/disk/'+form.filePath"
                                class="avatar"
                                style="max-width:300px"
                            />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <!-- <el-upload
                            ref="file"
                            list-type="picture-card"
                            :action="`${httpUrl}/file/UploadPng`"
                            :on-success="successFun"
                            :file-list="fileList"
                            :limit="1"
                            >
                            <img v-if="form.filePath" :src="httpUrl+'/disk/'+form.filePath" class="avatar">
                            <i class="el-icon-plus"></i>
                        </el-upload> -->
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="el-button" @click="cancel">取 消</el-button>
                <el-button class="el-button1" @click="save()">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    listByPage,//列表查询
    insert,
    querySingle,
    update,
    del
} from "../../../api/cooperation.js";
export default {
    name: "breadcrumbList",
    data() {
        return {
            httpUrl:process.env.VUE_APP_URL,
            tableData: [],
            dialogVisible: false,
            queryData: {
                currentPage: 1, //当前页
                pageSize: 10,
            },
            isAdd:0,
            form:{
                filePath:""
            },
            title:"",
        };
    },
    methods: {
        handleSizeChange(val) {
              this.queryData.pageSize = val;
              this.listByPageFun();
        },
        handleCurrentChange(val) {
              this.queryData.currentPage = val;
            this.listByPageFun()
        },
        //列表
        listByPageFun() {
            listByPage({
                currentPage: this.queryData.currentPage,
                pageSize: this.queryData.pageSize,
            })
                .then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data.list || [];
                        this.queryData.total = res.data.total;
                        this.queryData.pages = res.data.pages;
                    }else{
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                });
        },
        add(){
            this.title="新增";
            this.dialogVisible=true;
            this.isAdd=1;
        },
        edit(val){
            this.title="编辑";
            querySingle({id:val}).then(res=>{
                if(res.code==200){
                        this.dialogVisible=true;
                        this.form=res.data;
                        this.form.filePath=res.data.filePath;
                    }
                    else{
                        this.$message(res.message);
                    }
                })
                .catch(err => {
            });
        },
        successFun(file){
            this.form.fileId=file.data.id;
            this.form.filePath=file.data.filePath;
        },
        save(){
            if(this.isAdd==1){
                insert(this.form).then(res=>{
                    if(res.code==200){
                        this.$message.success("新增成功！");
                        this.cancel();
                    }
                    else{
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                });
            }
            else{
                update(this.form).then(res=>{
                    if(res.code==200){
                        this.$message.success("修改成功！");
                        this.cancel();
                    }
                    else{
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                });
            }
        },
        del(val){
            del({id:val}).then(res=>{
                if(res.code==200){
                        this.$message.success("删除成功！");
                        this.listByPageFun();
                    }
                    else{
                        this.$message(res.message);
                    }
                })
                .catch(err => {
            });
        },
        cancel(){
            this.isAdd=0;
            this.dialogVisible=false;
            this.form={filePath:""};
            this.listByPageFun();
            this.$refs.file.clearFiles();
        },

    },
    mounted() {},
    created() {
        this.listByPageFun();
    },
    computed: {
    }
};
</script>

<style lang="less" scoped>
.el-table {
    margin-top: 20px;
    /deep/ th .cell {
        font-weight: bold;
    }
    .el-button--text {
        color: #197cda;
    }
    .ql-editor {
        min-height: 150px;
    }
}
.flex-between {
    display: flex;
    justify-content: space-between;
}
.primary {
    width: 80px;
    height: 30px;
    background: rgba(0, 145, 255, 1);
    box-shadow: 0px 1px 3px 0px rgba(0, 72, 128, 0.3);
    border-radius: 4px;
    padding: 0;
}
.input_box {
    width: 300px;
    height: 36px;
    border: 1px solid rgba(153, 194, 255, 1);
    border-radius: 4px;
    input {
        width: 270px;
        height: 36px;
        line-height: 36px;
        font-style: italic;
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
        box-sizing: border-box;
        padding-left: 10px;
    }
}
.flex-end {
    display: flex;
    justify-content: flex-end;
    color: #999999;
    font-size: 14px;
    align-items: center;
    margin-top: 30px;
}
.avatar-uploader{
    .avatar-uploader-icon{
        padding:11px 25px;
        border-radius: 4px;
        border:1px #ccc solid;
    }
}
</style>
